import { SortIcon } from '@carboncopyco/icons';
import { Sorts } from '@carboncopyco/types';
import { DropdownFilter } from '@carboncopyco/ui';
import { sortOptions } from '../consts';
import { useUrlState } from '../utils';

const initialSortValue = 'last_updated';

export const SortDropdown = () => {
  const [urlState, setUrlState] = useUrlState(
    {
      sort: initialSortValue,
    },
    { allowedValues: { sort: Sorts } }
  );
  const { sort } = urlState;

  return (
    <DropdownFilter
      capsuleWidth={164}
      selected={sort}
      placeholder=""
      leftIcon={SortIcon}
      items={sortOptions}
      onSelect={(sort) => setUrlState({ ...urlState, sort })}
    />
  );
};
